import React, { useEffect, useState } from "react";
import AnalyzeIcon from "../assets/images/analyzeIcon.png";
import AnalyticsIcon from "../assets/images/analyticsIcon.png";
import Mangnifer from "../assets/images/Magnifier.png";
import { useDispatch, useSelector } from "react-redux";
import { getHoldingsData } from "../store/Slice/HoldingsSlice";

const Holdings = () => {
  const dispatch = useDispatch();
  const { userId } = useSelector((state) => state.auth);
  const { data } = useSelector((state) => state.holdings);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedValue, setSelectedValue] = useState("Stock Value");

  const holdingsData = () => {
    dispatch(getHoldingsData(userId));
  };

  useEffect(() => {
    holdingsData();
  }, []);

  const selectOptions = ["Stock Value", "Aasdas", "Basjdasjkh", "Cshdasjdhash"];

  return (
    <div className="w-full">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mt-8 px-8 gap-4">
        <div className="flex items-center gap-6">
          <h2 className="text-2xl font-semibold">
            Holdings({data[0]?.length})
          </h2>
          <select
            value={selectedValue}
            onChange={(e) => setSelectedValue(e.target.value)}
            className="border border-brand-border rounded-lg px-4 py-2 outline-none bg-white cursor-pointer"
          >
            {selectOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          {/* Search Box */}
          <div className="flex items-center">
            <div className="bg-brand-gray border-l border-t border-b border-brand-border rounded-l-lg px-2 py-2.5 flex items-center">
              <img src={Mangnifer} alt="magnifier" className="w-5 h-5" />
            </div>
            <input
              type="text"
              className="bg-brand-gray border-r border-t border-b border-brand-border rounded-r-lg px-3 py-2 outline-none placeholder:text-gray-400 w-[8.4rem] mr-1"
              placeholder="search"
              onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
            />
          </div>

          {/* Action Icons */}
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 cursor-pointer">
              <img src={AnalyticsIcon} alt="analytics" className="w-5 h-5" />
              <p className="text-primary text-sm">Authorization</p>
            </div>
            <div className="flex items-center gap-2 cursor-pointer">
              <img src={AnalyticsIcon} alt="analytics" className="w-5 h-5" />
              <p className="text-primary text-sm">Family</p>
            </div>
            <div className="flex items-center gap-2 cursor-pointer">
              <img src={AnalyticsIcon} alt="analytics" className="w-5 h-5" />
              <p className="text-primary text-sm">Analytics</p>
            </div>
            <div className="flex items-center gap-2 cursor-pointer">
              <img src={AnalyticsIcon} alt="download" className="w-5 h-5" />
              <p className="text-primary text-sm">Download</p>
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="mt-12 overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="h-[3.3rem] shadow-[0px_4px_6px_rgba(0,0,0,0.1)]">
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">
                Instrument
              </th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">
                Qty.
              </th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">
                Avg.cost
              </th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">
                LTP
              </th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">
                Cur.val
              </th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">
                P&L
              </th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">
                Net Chg.
              </th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">
                Day Chg.
              </th>
            </tr>
          </thead>
          <tbody>
            {data[0]?.length > 0 &&
              data[0]
                ?.filter((h) => {
                  return searchTerm === ""
                    ? h
                    : h?.intrument?.toLowerCase().includes(searchTerm);
                })
                ?.map((holding, index) => {
                  return (
                    <tr
                      key={index}
                      className="h-12 border-b border-brand-border"
                    >
                      <td className="text-center text-xl">
                        {holding?.intrument}
                      </td>
                      <td className="text-center text-xl text-primary">
                        {holding?.quantity}
                      </td>
                      <td className="text-center text-xl">
                        {holding?.avarageCost}
                      </td>
                      <td className="text-center text-xl text-green-500">
                        {holding?.ltp}
                      </td>
                      <td className="text-center text-xl">
                        {holding?.currValue?.toFixed(2)}
                      </td>
                      <td className="text-center text-xl text-green-500">
                        {holding?.pnl > 0 && "+"}
                        {holding?.pnl?.toFixed(2)}
                      </td>
                      <td className="text-center text-xl text-green-500">
                        {holding?.netChange}%
                      </td>
                      <td className="text-center text-xl text-green-500">
                        {holding?.dayChange}%
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Holdings;
